import React from "react";
import { cx } from "utils/join-classnames";
import styles from "./StateSwitch.module.scss";

interface Props {
    status: boolean;
    onChange: () => void;
    className?: string;
}

const StateSwitch: React.FC<Props> = ({ status, onChange, className }) => (
    <div
        className={cx(
            styles.switch__container,
            status ? styles.active : null,
            className,
        )}
        onClick={onChange}
        role="presentation"
    >
        <div className={styles.switch__btn} />
    </div>
);

export default StateSwitch;
